import { IconButton, styled } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { GLOBAL } from '../../../../utils/constants';

export const MuiIconButton = styled(IconButton,{
  shouldForwardProp: (prop) => prop !== 'enabled'
})(({ theme,enabled }) => ({
  color: enabled ? theme.palette.primary.main : GLOBAL.CUSTOM_GRAY_COLOR_PALETTE[700],
  '&:hover': {
    backgroundColor: 'transparent'
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: 'transparent',
  },
  padding: '0px !important'
}));

export const MuiArrowDropDownIcon = styled(ArrowDropDownIcon,{
  shouldForwardProp: (prop) => prop !== 'enabled'
})(({ theme,enabled }) => ({
  color: enabled ? theme.palette.primary.main : GLOBAL.CUSTOM_GRAY_COLOR_PALETTE[700],
  '&:hover': {
    backgroundColor: 'transparent'
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: 'transparent',
  },
  padding: '0px !important'
}));
